import { render } from "./VisualizaçãoPAP.vue?vue&type=template&id=04881e40&scoped=true"
import script from "./VisualizaçãoPAP.vue?vue&type=script&lang=js"
export * from "./VisualizaçãoPAP.vue?vue&type=script&lang=js"

import "./VisualizaçãoPAP.vue?vue&type=style&index=0&id=04881e40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04881e40"]])

export default __exports__